import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { STATUT_LIST, statutLabel } from './constants';

export default function MaintenanceDashboard({ currentUser, onCounterClick }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    (async () => {
      try { setStats((await api.get('/maintenance/stats')).data); }
      catch (err) { if (err.response?.status === 403) setDenied(true); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="table-empty">Chargement…</div>;
  if (denied) return <div className="table-container"><div className="table-empty">Accès non autorisé.</div></div>;
  if (!stats) return <div className="table-container"><div className="table-empty">Statistiques indisponibles.</div></div>;

  const Card = ({ num, label, alert, onClick }) => (
    <div className={`mnt-stat-card ${onClick ? 'clickable' : ''}`} onClick={onClick}>
      <div className={`mnt-stat-num ${alert ? 'alert' : ''}`}>{num}</div>
      <div className="mnt-stat-label">{label}</div>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--section-gap)' }}>
      <div className="mnt-section-label">Vue d'ensemble</div>
      <div className="mnt-stat-grid">
        <Card num={stats.total} label="Demandes (total)" />
        <Card num={stats.ce_mois} label="Créées ce mois" />
        <Card num={stats.urgentes} label="Urgentes ouvertes" alert={stats.urgentes > 0} onClick={() => onCounterClick({ urgence: true })} />
        <Card num={stats.en_retard} label="En retard" alert={stats.en_retard > 0} onClick={() => onCounterClick({ scope: 'en_retard' })} />
        <Card num={stats.delai_moyen_jours != null ? `${stats.delai_moyen_jours} j` : '—'} label="Délai moyen de clôture" />
      </div>

      <div className="mnt-section-label">Par statut</div>
      <div className="mnt-stat-grid">
        {STATUT_LIST.map((s) => (
          <Card key={s} num={stats.par_statut[s] || 0} label={statutLabel(s)} onClick={() => onCounterClick({ statut: s })} />
        ))}
      </div>

      {stats.top_sites?.length > 0 && (
        <>
          <div className="mnt-section-label">Sites les plus sollicités (demandes ouvertes)</div>
          <div className="table-container">
            <table>
              <thead><tr><th>Site</th><th style={{ textAlign: 'right' }}>Demandes ouvertes</th></tr></thead>
              <tbody>
                {stats.top_sites.map((t, i) => (
                  <tr key={i}>
                    <td>{t.site_nom || '— (non renseigné)'}</td>
                    <td style={{ textAlign: 'right', fontWeight: 600 }}>{t.n}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
